// extracted by mini-css-extract-plugin
export var sectionbreak = "SponsorMeButton-module--sectionbreak--ad15a";
export var sponsormebuttoncontainer = "SponsorMeButton-module--sponsormebuttoncontainer--16e10";